module.exports = __webpack_public_path__ + "img/habeinleumi-small.534c0339.svg";